import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/plus_icon.png'
import _imports_1 from '@/assets/images/more_than.png'


const _hoisted_1 = { class: "task-item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "entry-plus-icon",
  src: _imports_0
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "line-one-first-block" }
const _hoisted_5 = {
  key: 0,
  class: "parent-task default-text-grey"
}
const _hoisted_6 = {
  key: 1,
  class: "parent-task-icon-block"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "parent-task-icon",
  src: _imports_1
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "task-name default-text-grey" }
const _hoisted_10 = { class: "line-one-second-block" }
const _hoisted_11 = { class: "chip-block-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_status_chip = _resolveComponent("status-chip")!
  const _component_progress_bar = _resolveComponent("progress-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tooltip, {
      text: _ctx.plusButtonTooltip,
      positionFromTop: _ctx.plusButtonTooltipPositionFromTop
    }, {
      default: _withCtx(() => [
        (_ctx.showFirstElement)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "first-element",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createTimeEntry && _ctx.createTimeEntry(...args)))
            }, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["text", "positionFromTop"]),
    _createElementVNode("div", {
      class: _normalizeClass(["second-element", { 'selected-border': _ctx.isSelected }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.seeTaskInfo()))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["line-one", { 'line-one-max-height': !_ctx.remainingTime }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["task-color", _ctx.task?.color])
          }, null, 2),
          (_ctx.task?.parent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.task?.parent), 1))
            : _createCommentVNode("", true),
          (_ctx.task?.parent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.task?.task_name), 1)
        ]),
        (_ctx.remainingTime)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["time-remaining medium-text-grey", { 'time-remaining-only': !_ctx.showStatus }])
            }, _toDisplayString(_ctx.remainingTime), 3))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_tooltip, {
              text: _ctx.statusChipsTooltip,
              positionFromTop: _ctx.chipsTooltipPositionFromTop
            }, {
              default: _withCtx(() => [
                (_ctx.task?.custom_fields?.status && _ctx.showStatus)
                  ? (_openBlock(), _createBlock(_component_status_chip, {
                      key: 0,
                      chipContent: _ctx.task.custom_fields.status?.value,
                      filterColor: _ctx.task.custom_fields.status?.color,
                      size: 'md'
                    }, null, 8, ["chipContent", "filterColor"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["text", "positionFromTop"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["chip-block-second", { 'chip-block-second-not-showed': !_ctx.showPriority }])
          }, [
            _createVNode(_component_tooltip, {
              text: _ctx.priorityChipsTooltip,
              positionFromTop: _ctx.chipsTooltipPositionFromTop
            }, {
              default: _withCtx(() => [
                (_ctx.task?.custom_fields?.priority && _ctx.showPriority)
                  ? (_openBlock(), _createBlock(_component_status_chip, {
                      key: 0,
                      chipContent: _ctx.task.custom_fields.priority?.value,
                      filterColor: _ctx.task.custom_fields.priority?.color,
                      size: 'sm'
                    }, null, 8, ["chipContent", "filterColor"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["text", "positionFromTop"])
          ], 2)
        ])
      ], 2),
      _createVNode(_component_progress_bar, {
        ref: "taskItemProgressBar",
        taskItemView: true
      }, null, 512)
    ], 2)
  ]))
}